import React, { useState, useEffect, useCallback } from "react";
import "./ScrollToTopButton.scss";

interface ScrollToTopButtonProps {
    startLine?: number;
    scrollTo?: number;
    scrollDuration?: number;
    fadeDuration?: [number, number];
    offsetX?: number;
    offsetY?: number;
    className?: string;
}

const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({
    startLine = 100,
    scrollTo = 0,
    fadeDuration = [300, 300],
    offsetX = 30,
    offsetY = 30,
    className = "",
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isScrolling, setIsScrolling] = useState(false);

    const toggleControl = useCallback(() => {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
        const newShouldVisible = scrollTop >= startLine;
        // setShouldVisible(newShouldVisible);

        if (newShouldVisible && !isVisible) {
            setIsVisible(true);
            document.body.classList.add("throughHd");
        } else if (!newShouldVisible && isVisible) {
            setIsVisible(false);
            document.body.classList.remove("throughHd");
        }
    }, [startLine, isVisible]);

    const scrollUp = useCallback(() => {
        const targetElement =
            typeof scrollTo === "string"
                ? document.getElementById(scrollTo)
                : null;
        const destination = targetElement
            ? targetElement.offsetTop
            : typeof scrollTo === "number"
            ? scrollTo
            : 0;

        // スクロール開始時にスケールを大きくする
        setIsScrolling(true);

        window.scrollTo({
            top: destination,
            behavior: "smooth",
        });

        // スクロール完了を検知してスケールを戻す
        const checkScrollEnd = () => {
            const currentScrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            if (Math.abs(currentScrollTop - destination) < 5) {
                setIsScrolling(false);
            } else {
                requestAnimationFrame(checkScrollEnd);
            }
        };

        // 少し遅延してからチェック開始（スムーススクロールの開始を待つ）
        setTimeout(() => {
            checkScrollEnd();
        }, 50);
    }, [scrollTo]);

    useEffect(() => {
        const handleScroll = () => {
            toggleControl();
        };

        const handleResize = () => {
            toggleControl();
        };

        // 初期チェック
        toggleControl();

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
            // クリーンアップ時にクラスを削除
            document.body.classList.remove("throughHd");
        };
    }, [toggleControl]);

    return (
        <div
            id="topcontrol"
            className={`scroll-to-top-button ${className} ${
                isVisible ? "visible" : ""
            } ${isScrolling ? "scrolling" : ""}`}
            style={{
                right: `${offsetX}px`,
                bottom: `${offsetY}px`,
                opacity: isVisible ? 1 : 0,
                transition: `opacity ${
                    isVisible ? fadeDuration[0] : fadeDuration[1]
                }ms ease, transform 200ms ease`,
                transform: isScrolling ? "scale(1.5)" : "scale(1)",
            }}
            onClick={scrollUp}
            title="Scroll Back to Top"
        >
            <span></span>
        </div>
    );
};

export default ScrollToTopButton;
